export default {
    /**
     * Cached computed methods for complex logic on the view layer.
     *
     * @link https://vuejs.org/v2/guide/computed.html
     *
     * @type Object The computed functions
     */
    computed: {
        mq_isMobile () {
            return this.$mq === 'xs' || this.$mq === 'sm';
        },
        mq_isHandheld () {
            return this.$mq === 'xs' || this.$mq === 'sm' || this.$mq === 'md';
        },
        mq_isTablet () {
            return this.$mq === 'md' || this.$mq === 'lg';
        },
        mq_isDesktop () {
            return this.mq_isLargePlus;
        },
        mq_isWidescreenDesktop () {
            return this.mq_isExtraLargePlus;
        },
        mq_isSmallPlus () {
            return this.$mq !== 'xs';
        },
        mq_isMediumPlus () {
            return this.$mq !== 'xs' && this.$mq !== 'sm';
        },
        mq_isLargePlus () {
            return this.$mq === 'lg' || this.$mq === 'xl' || this.$mq === 'xxl';
        },
        mq_isExtraLargePlus () {
            return this.$mq === 'xl' || this.$mq === 'xxl';
        },
        mq_isMicro () {
            return this.$mq === 'xs';
        },
        mq_isSmall () {
            return this.$mq === 'sm';
        },
        mq_isMedium () {
            return this.$mq === 'md';
        },
        mq_isLarge () {
            return this.$mq === 'lg';
        },
        mq_isExtraLarge () {
            return this.$mq === 'xl';
        },
        mq_isMassive () {
            return this.$mq === 'xxl';
        },
    },
};
